import { CalendarDays } from "lucide-react"
import { useAuthStore } from "@/features/auth/store"

const DATE_FORMATTER = new Intl.DateTimeFormat("pl-PL", {
  weekday: "long",
  day: "numeric",
  month: "long",
  year: "numeric",
})

const HOURS_FORMATTER = new Intl.DateTimeFormat("pl-PL", {
  hour: "2-digit",
  minute: "2-digit",
})

function firstName(fullName: string): string {
  return fullName.trim().split(/\s+/)[0] ?? fullName
}

/** "Dzień dobry" / "Cześć" / "Dobry wieczór" zależnie od pory dnia. */
function greetingPrefix(hour: number): string {
  if (hour < 6) return "Dzień dobry"
  if (hour < 12) return "Cześć"
  if (hour < 18) return "Dzień dobry"
  return "Dobry wieczór"
}

export function DashboardGreeting() {
  const user = useAuthStore((s) => s.user)
  const now = new Date()
  const today = DATE_FORMATTER.format(now)
  const time = HOURS_FORMATTER.format(now)
  const name = user ? firstName(user.fullName) : ""
  const prefix = greetingPrefix(now.getHours())

  return (
    <div className="space-y-2">
      <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-emerald-700">
        <span className="size-1.5 rounded-full bg-emerald-500" />
        Pulpit
      </span>
      <h1 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-[2.25rem]">
        {user ? `${prefix}, ${name}` : "Pulpit"}
      </h1>
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <CalendarDays className="size-4 text-slate-400" />
        <span className="capitalize">{today}</span>
        <span className="text-slate-300">·</span>
        <span className="tabular-nums">{time}</span>
      </div>
    </div>
  )
}
